








































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Mutation, State, Getter, Action } from 'vuex-class';
import { client } from '@/store';
import { IAgreement, IProposal, IContractor, IUser } from '@/models';
import { BaseDetail } from '../Base/BaseDetail';
import { getUserFullName } from '@/helpers/functions';
const namespace = 'agreement';
const ns = { namespace };
@Component({
  methods: {
    getUserFullName,
  },
})
export default class AgreementDetail extends BaseDetail<IAgreement> {
  namespace = namespace;
  @State('entities', ns) entities: Record<string, IAgreement>;
  @State('entities', { namespace: 'proposal' }) proposals: Record<
    string,
    IProposal
  >;
  @State('entities', { namespace: 'contractor' }) contractors: Record<
    string,
    IContractor
  >;
  @State('entities', { namespace: 'employee' }) employees: Record<
    string,
    IContractor
  >;
  @State('currentUser', { namespace: 'user' }) user: IUser;
  @Action('createEntity', ns) createEntity: any;
  @Action('getEntity', ns) getEntity: any;
  @Action('pushMessage', ns) pushMessage: any;
  @Action('updateEntity', ns) updateEntity: any;
  @Action('deleteEntity', ns) deleteEntity: any;
  mounted() {
    this.setValue(this.entityPatch, 'creator_id', this.user.id);
    this.loadEntity();
  }
}
